import { NotFoundComponent } from './not-found/not-found.component';

export const CONTAINERS = [NotFoundComponent];

export { NotFoundComponent } from './not-found/not-found.component';
